<template>
<div id="survey-start-page">
  <div class="mb-2"><span :class="`${styles.pageTitle} indigo--text ml-2`"><strong>{{$t('설문 완료')}}</strong></span></div>
  <v-card 
    :class="`${$vuetify.breakpoint.smAndDown ? 'elevation-0':'elevation-10'}`"
  >
    <!-- :elevation="$vuetify.breakpoint.mobile ? 0 : $vuetify.breakpoint.md ? 10 : 10" -->
    <!-- :class="$vuetify.breakpoint.mobile ? null : 'ma-2'" -->
    <!-- 설문 완료 요청 페이지 타이틀 START -->
    <v-card-title primary-title class="justify-left">
          <span :class="styles.header"><strong>{{ $t('설문 제출이 완료되었습니다.') }}</strong></span>
    </v-card-title>
    <!-- 설문 완료 요청  페이지 타이틀 END -->
    <v-divider></v-divider>
    <!-- 설문 완료 요청  페이지 설명 START -->
    <v-card-text class="justify-center mt-4">
          <pre :class="`${styles.description} mx-4`">{{ $t("설문 제출이 정상적으로 완료되었습니다. \n이제 브라우저 탭을 닫아주세요.") }}</pre>
    </v-card-text>
    <!-- 설문 완료 요청  페이지 설명 END -->
    <!-- 액션 영역 START -->
    <v-card-actions class="mt-10">
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
    </v-card-actions>
    <!-- 액션 페이지 타이틀 END -->
  </v-card>
  </div>
</template>

<script>
export default {
  props: {
    properties: {
      type: Object,
    },
    rid: {
      type: String,
      required: true,
    },
    targetKey: {
      type: String,
    }
  },
  computed: {
    styles() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return {
            pageTitle: 'text-h6',
            header: 'text-subtitle-1', 
            description: 'text-subtitle-1 content-description mx-5'
          }
        default:
          return {
            pageTitle: 'text-h5',
            header: "text-h6",
            description: 'text-subtitle-1 content-description mx-5'
          }
      }
    }
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.content-description {
  white-space: pre-wrap; 
}
</style>